//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AplicacionesAPI from '@/api/promotores/aplicaciones.api'
export default {
  data() {
    return {
      aplicaciones: [],
      loading: false,
      columns: [
        { name: 'id', label: 'ID', field: 'id', sortable: true, align: 'left', style: "width: 10px" },
        { 
          name: 'nombre', 
          label: 'Aplicación', 
          field: 'nombre', 
          sortable: true, 
          align: 'left',
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
        },
        { name: 'codigo', label: 'Código', field: 'codigo', align: 'left' },
        { name: 'descripcion', label: 'Descripción', field: 'descripcion', align: 'left' },
        { name: 'api_token', label: 'API Token', field: 'api_token', align: 'left' },
        { name: 'created_at', label: 'Creación', field: 'created_at', align: 'left' },
      ],
    }
  },

  mounted() {
    this.loadAplicaciones()
  },

  methods: {
    async loadAplicaciones() {
      try {
        this.loading = true
        this.aplicaciones = await AplicacionesAPI.all()
      } finally {
        this.loading = false
      }
    },
    copyApiToken({ api_token }) {
      navigator.clipboard.writeText(api_token);
    }
  }
}
